import { Link } from 'react-router-dom';
import { MapPin, Mail } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const LOGO_URL = "/images/basic-united-logo-light.png";

const T = {
  desc: {
    de: 'Basic United Holding GmbH ist die Muttergesellschaft einer wachsenden Unternehmensgruppe mit Fokus auf Logistik, Beratung und Dienstleistungen.',
    en: 'Basic United Holding GmbH is the parent company of a growing corporate group focused on logistics, consulting and services.',
  },
  nav: { de: 'Navigation', en: 'Navigation' },
  legal: { de: 'Rechtliches', en: 'Legal' },
  home: { de: 'Startseite', en: 'Home' },
  about: { de: 'Über Uns', en: 'About Us' },
  companies: { de: 'Unternehmen', en: 'Companies' },
  contact: { de: 'Kontakt', en: 'Contact' },
  imprint: { de: 'Impressum', en: 'Imprint' },
  privacy: { de: 'Datenschutz', en: 'Privacy Policy' },
  rights: { de: 'Alle Rechte vorbehalten.', en: 'All rights reserved.' },
};

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();

  return (
    <footer data-testid="main-footer" className="bg-[#0F1A2E] text-white">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Basic United Holding GmbH" 
              className="h-11 w-auto mb-6"
            />
            <p className="text-white/80 leading-relaxed mb-6 max-w-md">
              {T.desc[language]}
            </p>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#F5A623] mt-1 flex-shrink-0" />
                <span className="text-white/80">
                  Schneiderstraße 63<br />
                  40764 Langenfeld (Rheinland)
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-[#F5A623] flex-shrink-0" />
                <a href="mailto:info@basic-united.de" className="text-white/80 hover:text-[#F5A623] transition-colors">
                  info@basic-united.de
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">{T.nav[language]}</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/80 hover:text-[#F5A623] transition-colors" data-testid="footer-link-startseite">{T.home[language]}</Link></li>
              <li><Link to="/ueber-uns" className="text-white/80 hover:text-[#F5A623] transition-colors" data-testid="footer-link-ueber-uns">{T.about[language]}</Link></li>
              <li><Link to="/unternehmen" className="text-white/80 hover:text-[#F5A623] transition-colors" data-testid="footer-link-unternehmen">{T.companies[language]}</Link></li>
              <li><Link to="/kontakt" className="text-white/80 hover:text-[#F5A623] transition-colors" data-testid="footer-link-kontakt">{T.contact[language]}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">{T.legal[language]}</h4>
            <ul className="space-y-3">
              <li><Link to="/impressum" className="text-white/80 hover:text-[#F5A623] transition-colors" data-testid="footer-link-impressum">{T.imprint[language]}</Link></li>
              <li><Link to="/datenschutz" className="text-white/80 hover:text-[#F5A623] transition-colors" data-testid="footer-link-datenschutz">{T.privacy[language]}</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-main py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              &copy; {currentYear} Basic United Holding GmbH. {T.rights[language]}
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/impressum" className="text-white/60 hover:text-[#F5A623] transition-colors">{T.imprint[language]}</Link>
              <span className="text-white/30">|</span>
              <Link to="/datenschutz" className="text-white/60 hover:text-[#F5A623] transition-colors">{T.privacy[language]}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
